import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import {
  getRoles,
  deleteRole,
} from "../../../api/settings/roleManager";
import { toast } from "react-toastify";
import CreateDrawer from "./RoleCreateDrawer";
import RowAction from "./RoleRowAction";
import Pagination from "./RolePagination";
import Filter from "./RoleFilter";

export default function RoleManager() {
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
    } catch (err) {
      toast.error("Failed to load roles");
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Role List</h1>

      <Filter onNewClick={() => {
        setSelectedRole(null);
        setShowDrawer(true);
      }} />

      {/* <div className="border rounded-md overflow-x-auto">
        <table className="w-full table-auto text-sm bg-white">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2">Code</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Description</th>
              <th className="px-3 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  No data found.
                </td>
              </tr>
            ) : (
              roles.map((role) => (
                <tr key={role.id} className="border-t hover:bg-gray-50">
                  <td className="px-3 py-2">{role.id}</td>
                  <td className="px-3 py-2">{role.name}</td>
                  <td className="px-3 py-2">{role.description}</td>
                  <td className="px-3 py-2">
                    <RowAction
                      data={role}
                      onEdit={() => {
                        setSelectedRole(role);
                        setShowDrawer(true);
                      }}
                      onDeleted={fetchRoles}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div> */}


<div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
  <div className="overflow-x-auto">
    <table className="w-full text-left border-collapse">
      <thead className="bg-gray-50/50 border-b border-gray-100">
        <tr>
          {/* Cột STT nhỏ gọn */}
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest w-20 text-center">STT</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest w-32">Mã Code</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Tên vai trò</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Mô tả chi tiết</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest text-center">Hành động</th>
        </tr>
      </thead>
      
      <tbody className="divide-y divide-gray-50">
        {roles.length === 0 ? (
          <tr>
            <td colSpan={5} className="p-20 text-center">
              <div className="flex flex-col items-center gap-3">
                <div className="w-16 h-16 rounded-3xl bg-gray-50 flex items-center justify-center border-2 border-dashed border-gray-200 text-gray-300">
                   <FontAwesomeIcon icon={faBoxOpen} size="lg" />
                </div>
                <p className="text-gray-400 font-black italic uppercase text-xs tracking-widest">
                  Chưa có dữ liệu vai trò
                </p>
              </div>
            </td>
          </tr>
        ) : (
          roles.map((role, index) => (
            <tr key={role.id} className="hover:bg-gray-50/50 transition-colors group">
              {/* STT */}
              <td className="p-5 text-center">
                <span className="text-xs font-bold text-gray-400">
                  {index + 1}
                </span>
              </td>

              {/* Code: Badge style */}
              <td className="p-5">
                <span className="px-3 py-1 bg-slate-100 text-slate-600 rounded-lg text-[11px] font-black uppercase tracking-tighter border border-slate-200">
                  {role.id}
                </span>
              </td>

              {/* Name: Font bold & highlight */}
              <td className="p-5">
                <p className="font-black text-gray-800 text-sm group-hover:text-red-700 transition-colors">
                  {role.name}
                </p>
              </td>

              {/* Description: Thêm line-clamp để tránh vỡ dòng */}
              <td className="p-5">
                <p className="text-sm font-medium text-gray-500 line-clamp-1 max-w-md">
                  {role.description || "—"}
                </p>
              </td>

              {/* Actions: Căn giữa */}
              <td className="p-5">
                <div className="flex justify-center items-center">
                  <RowAction
                    data={role}
                    onEdit={() => {
                      setSelectedRole(role);
                      setShowDrawer(true);
                    }}
                    onDeleted={fetchRoles}
                  />
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</div>

      <Pagination
        totalRecords={roles.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
      />

      <CreateDrawer
        open={showDrawer}
        onOpenChange={setShowDrawer}
        data={selectedRole}
        onRefresh={fetchRoles}
        onSaved={() => {
          fetchRoles();
          setShowDrawer(false);
        }}
      />
    </div>
  );
}
